import { get } from "@/utils/request";

export default {
  // 首页获取视频地址
  getVideoList: (params) => get("/prod-api/api/video/list", params),
  // 获取 推荐企业信息
  getProductsList: (params) => get("/prod-api/api/products/list", params),

  // 获取企业列表
  getMerchantList: (params) => get("/prod-api/api/merchant/list", params),
  // 获取统计信息
  getStatisticsRegularCount: (params) =>
    get("/prod-api/statistics/regularCount", params),
  // 招商政策
  getArticleList: (params) => get("/prod-api/api/article/list", params),
  //招商信息
  getInvestList: (params) => get("/prod-api/api/invest/list", params),
  //地区生产总值
  getProfitList: (params) => get("/prod-api/api/profit/list", params),
  // 企业监控列表
  getControlList: (params) => get("/prod-api/api/control/list", params),
  //  获取招聘信息列表
  getRecruitList: (params) => get("/prod-api/api/recruit/list", params),
  // 获取家庭医生列表
  getLtDoctorCount: (params) =>
    get("/prod-api/statistics/ltDoctorCount", params),
  // 区域招商企业统计
  getLtMerchantCount: (params) =>
    get("/prod-api/statistics/ltMerchantCount", params),

  // http://localhost:9010/statistics/ltMerchantCount
};
